import { combineSlices } from '@reduxjs/toolkit';
import { mainAssortmentSlice } from './assortment/redux';
import { ownAssortmentSlice } from './ownAssortment/redux';

export const assortmentReducer = combineSlices(
  mainAssortmentSlice,
  ownAssortmentSlice,
);
